const Social = (props) => {

  function gototel() {
    window.location.href = 'https://t.me/buartsoft';
  }

  function gotowp() {
    window.location.href = 'https://wa.me/905454813747';
  }

  return (
    <div className="container">
      <div className="contacts-wp">
        <div className="col-12 row">
          <p className="socialslogan">{props.keepintouch}</p>



              <div className="col-md-8 offset-md-2 contacts-item colleft">
                <button type="button" onClick={gotowp} class="socialHeadButtonWhatsapp">
                  <img className="socialmobileiconhead" src="icons/social/whatsapp.svg" alt=""/>
                   &nbsp; Whatsapp
                </button>
              </div>

        </div>
      </div>
    </div>
  );
}

export default Social;
